<template>
      <iframe 
        :src="iframe.src"
        :style="iframe.style"
        :height="iframe.style.height"
        :width="iframe.style.width"
        frameborder="0"
      ></iframe>

</template>
<script>
export default {
  data() {
    return {
      loaded: false,
      iframe: {
        src: "",
        style: null,
        wrapperStyle: null,
      }
    }
  },
  created() {
    this.cambioTitulo()
    // this.iframe.src='http://localhost:8080/foro-yet/#/inicio-externo/5f9693fb8a35f87af8d4ec83/61b2aa8e269973e053a3734c71b4eb36'
    this.iframe.src = 'https://b2b.textura-interiors.com/foro-yet/#/inicio-externo/' + localStorage.getItem("useruid") + '/' + localStorage.getItem("tokenOauth")
    
    this.iframe.style = {
      position: 'absolute',
      width: window.innerWidth-61,
      height: window.innerHeight-47,
    }    
    this.iframe.wrapperStyle = {
      overflow: 'hidden',
    } 
  },
  methods :{
    cambioTitulo () {
      this.$store.state.tituloIcono = `<i class="icon-bubbles4"></i>`
      this.$store.state.titulo = "Foro"
    },
  }
}
</script>
